import styled, { css } from "styled-components";
import { Button, ButtonProps } from "rebass";

interface IControlButton extends ButtonProps {
  isOpen: boolean;
}

export const ControlButton = styled(Button)<IControlButton>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 60px;
  height: 60px;
  padding: 0;
  border-color: #c3c5d8;
  background-color: #fff;
  transition: all .4s;

  ${({ isOpen, theme }) => !isOpen && css`
    border-color: ${theme.colors["sp-gray2"]};
    background-color: ${theme.colors["sp-gray2"]};
  `}
`;

ControlButton.defaultProps = {
  type: "button",
  border: "1px solid",
  borderRadius: "4px",
};

